/* eslint-disable prettier/prettier */
export const Udata = {
    "ul_1_1": {
      id: "ul_1_1",
      title: "编写测试计划",
      content: ["1. 明确本次测试的目标，让测试内容更聚焦", "2. 界定清楚测试内容，规划时间安排"],
      cards: [{
        title: "编写测试计划",
        content: ["围绕测试目标，针对关键功能、体验路径，设计用以测试的任务场景；并设计用户招募方案，确定用户筛选的条件和样本量"],
        url: "https://ueclub.kingdee.com/p/634653d5eaae8200234d463f?articleType=5f58abdde76d15d6a58e6104"
      }],
      download: [{
        title: "测试任务表模板&示例",
        sourceFile: {"ext":"xlsx","file_id":"226720866","folder_id":"2806024","mtime":"1666264112","name":"测试任务表模板及示例.xlsx","size":"12101","skey":"152668ddee700383aa918ccccc70014a"}
      }]
    },
    "ul_1_2": {
      id: "ul_1_2",
      title: "招募用户",
      content: ["1. 通过问卷，招募并筛选合适的测试用户", "2. 通过电话等方式向用户发出明确邀约"],
      cards: [{
        title: "问卷招募用户",
        content: ["创建一份用户招募问卷，设置用户筛选问题，以筛选出符合测试要求的用户，并选择合适的渠道推送问卷"],
        url: "https://ueclub.kingdee.com/p/634663b68243eb001f3eec91?articleType=5f58abdde76d15d6a58e6104"
      }, {
        title: "筛选并邀约测试用户",
        content: ["对招募到的用户，根据一定的原则，筛选出合适的测试用户，并邀约用户，确定用户可测试的时间"],
        url: "https://ueclub.kingdee.com/p/634654f8eaae8200234d4641?articleType=5f58abdde76d15d6a58e6104"
      }],
      download: [{
        title: "用户招募问卷示例文档",
        sourceFile: {"ext":"xlsx","file_id":"226720883","folder_id":"2806024","mtime":"1666264200","name":"用户招募问卷示例.xlsx","size":"12451","skey":"272d16073da5a10f0e7754e0a26799a4"}
      }, {
        title: "用户信息表模板",
        sourceFile: {"ext":"xlsx","file_id":"226720897","folder_id":"2806024","mtime":"1666264254","name":"用户信息表模板.xlsx","size":"10064","skey":"da3b3e7c9b81acafd75eac55fbaeeddf"}
      }]
    },
    "ul_1_3": {
      id: "ul_1_3",
      title: "物料准备",
      content: ["为正式测试做好时间、体验环境和工具上的准备，以保证测试的顺利完成。"],
      cards: [{
        title: "准备体验环境，预约时间",
        content: ["1. 准备好稳定可访问的产品体验环境", "2. 邀请内部人员进行预测试", "3. 提前预约用户和相关干系人时间"],
        url: "https://ueclub.kingdee.com/p/634655a0eaae8200234d4643?articleType=5f58abdde76d15d6a58e6104"
      }, {
        title: "准备测试工具",
        content: ["工欲善其事必先利其器，在测试开始前，准备并熟悉测试时需要用到的相关工具，有助于提高工作效率"],
        url: "https://ueclub.kingdee.com/p/634658d0eaae8200234d4644?articleType=5f58abdde76d15d6a58e6104"
      }]
    },
    "ul_2_1": {
      id: "ul_2_1",
      title: "暖场",
      content: ["开始测试时，要给用户营造良好的测试环境和轻松的交流氛围，让用户放松下来。"],
      cards: [{
        title: "营造良好的测试环境",
        content: ["1. 帮助用户创造良好的测试环境", "2. 开启腾讯会议云录制"],
        url: "https://ueclub.kingdee.com/p/63465574eaae8200234d4642?articleType=5f58abdde76d15d6a58e6104"
      }, {
        title: "暖场寒暄",
        content: ["测试开场，向用户介绍自己及参与本次测试的团队成员，说明测试目的，跟用户寒暄几句，能够有效拉近与用户的信任关系，让用户放松下来，有利于测试的进行"],
        url: "https://ueclub.kingdee.com/p/63465497eaae8200234d4640?articleType=5f58abdde76d15d6a58e6104"
      }]
    },
    "ul_2_2": {
      id: "ul_2_2",
      title: "任务测试",
      content: ["引导用户完成可用性测试任务，并记录典型的用户操作/页面"],
      cards: [{
        title: "完成测试流程",
        content: ["按照编写好的测试计划，与用户一起完成整个测试流程。在测试过程中注意观察用户操作，并做好相应记录。"],
        url: "https://ueclub.kingdee.com/p/634671fc65d83a0023e0027e?articleType=591e5fb0d82529145405981f"
      }],
      download: [{
        title: "任务记录模板",
        sourceFile: {"ext":"xlsx","file_id":"226720913","folder_id":"2806024","mtime":"1666264313","name":"任务记录表模版.xlsx","size":"19734","skey":"5e6fede2734c542a0f897b6ceeae79e2"}
      }]
    },
    "ul_2_3": {
      id: "ul_2_3",
      title: "任务评估",
      content: ["从多个角度对任务的可用性水平进行评估"],
      cards: [{
        title: "任务可用性评估",
        content: ["这一步需要对用户的测试任务的完成情况及时评估，并且在过程中适时与用户互动，了解用户对测试任务的感受。"],
        url: "https://ueclub.kingdee.com/p/634674fd65d83a0023e0027f?articleType=591e5fb0d82529145405981f"
      }]
    },
    "ul_2_4": {
      id: "ul_2_4",
      title: "测试后评分",
      content: ["了解用户对产品整体可用性的主观感受，收集可量化的信息。"],
      cards: [{
        title: "测试中的常用量表介绍",
        content: ["在用户完成所有可用性任务后，通过面向用户的测试量表获取可用性测试的量化信息，了解用户对产品整体的主观感受。"],
        url: "https://ueclub.kingdee.com/p/63467fe265d83a0023e00284?articleType=591e5fb0d82529145405981f"
      }],
      download: [{
        title: "测试中的量表",
        sourceFile: {"ext":"xlsx","file_id":"226720927","folder_id":"2806024","mtime":"1666264366","name":"测试中的量表.xlsx","size":"19591","skey":"b29aaf0ae0e4cf8087ae0620770f2c4d"}
      }]
    },
    "ul_2_5": {
      id: "ul_2_5",
      title: "致谢与结束",
      content: ["鼓励用户再次参与可用性测试"],
      cards: [{
        title: "致谢与结束",
        content: ["作为测试的收尾工作，首先检查测试任务表，查漏补缺；此外，向用户致谢，并赠送礼品，保持用户参与调研的积极性。"]
      }]
    },
    "ul_3_1": {
      id: "ul_3_1",
      title: "数据分析与结果报告",
      content: ["归纳总结主客观数据，评估产品的可用性，并协同团队成员提升使用体验"],
      cards: [{
        title: "报告可用性测试结果",
        content: ["这一部分需要做的工作有：测试资料建档归类；填写可用性问题汇总表；进行可用性测试报告。"],
        url: "https://ueclub.kingdee.com/p/63468ff865d83a0023e00287?articleType=591e5fb0d82529145405981f"
      }],
      download: [{
        title: "问题汇总表模板",
        sourceFile: {"ext":"xlsx","file_id":"226720974","folder_id":"2806024","mtime":"1666264511","name":"可用性问题清单.xlsx","size":"18030","skey":"efb85f49631cbf11401b90a0412bcdca"}
      },{
        title: "可用性测试报告模板",
        sourceFile: {"ext":"pdf","file_id":"226720991","folder_id":"2806024","mtime":"1666264573","name":"可用性测试报告参考.pdf","size":"1632302","skey":"add2fcdce9c185daa7a96958552d0f0f"}
      }]
    }
  }